import React from 'react'
import { Paper } from '@mui/material';
import { Button } from '@mui/material';
import FormDialog from '../panel/modal';
import AddRecruiterForm from '../form/addRecruiter';
import { useNavigate } from 'react-router-dom';
// import ViewStudents from '../table/viewStudents';
import ViewRecruiter from '../table/viewRecruiter';

const Recruiter = () => {

    const navigation = useNavigate();

    const [open, setOpen] = React.useState(false);
    const [modalData, setModalData] = React.useState();

    const handleClickOpen = (data) => {
        setOpen(true);
        setModalData(data);
    };
    const handleClose = () => {
        setOpen(false);
    };




    return (
        <>
            <div className="row">
                <Paper elevation={3}>
                    <div className="col-12 p-2">
                    </div>

                    <div className="col-12 d-flex justify-content-between p-2">
                        <div></div>
                        <Button variant='contained' onClick={handleClickOpen}>+Add Recruiter</Button>
                    </div>

                    {/* <AddStudenetForm/> */}

                    <FormDialog form={<AddRecruiterForm handleClose={handleClose} handleClickOpen={handleClickOpen} modalData={modalData} />} title='Add Recruiter' open={open} handleClickOpen={handleClickOpen} handleClose={handleClose} />
                </Paper>

                <Paper>
                    <div className="col-12">
                        <ViewRecruiter handleClickOpen={handleClickOpen} />
                    </div>
                </Paper>
            </div>
        </>
    )
}

export default Recruiter;